import { render } from "./StudentMessagesBlock.vue?vue&type=template&id=7f7ac20b&scoped=true"
import script from "./StudentMessagesBlock.vue?vue&type=script&lang=js"
export * from "./StudentMessagesBlock.vue?vue&type=script&lang=js"

import "./StudentMessagesBlock.vue?vue&type=style&index=0&id=7f7ac20b&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/standart-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f7ac20b"]])

export default __exports__